export const environment = {
  production: true,
  apihost: 'https://mali-onlinefusion-server.revenuedev.org',
  accessToken: 'rdf_fusacc_tkn'
};